export const scheduleInvoicesConstants = {
  SET_PURCHASE_SHOULD_NOTIFY: 'SET_PURCHASE_SHOULD_NOTIFY',
  SET_UPLOAD_SHOULD_NOTIFY: 'SET_UPLOAD_SHOULD_NOTIFY',
}
